import { render, staticRenderFns } from "./TestReportList.vue?vue&type=template&id=6f5b63bd&scoped=true"
import script from "./TestReportList.vue?vue&type=script&lang=js"
export * from "./TestReportList.vue?vue&type=script&lang=js"
import style0 from "./TestReportList.vue?vue&type=style&index=0&id=6f5b63bd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f5b63bd",
  null
  
)

export default component.exports